import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { SaleProductPickerPageRoutingModule } from './sale-product-picker-routing.module';

import { SaleProductPickerPage } from './sale-product-picker.page';
import { SalonMonsterTapRetryModule } from '../../../components/smr-tap-retry/smr-tap-retry.module';
import { SalonMonsterLoadMaskModule } from '../../../components/smr-load-mask/smr-load-mask.module';
import { StylistPickerModule } from '../../../components/stylist-picker/stylist-picker.module';
import { ProductListComponentModule } from '../../../components/product-list/product-list.module';

//import { BarcodeScanner } from '@awesome-cordova-plugins/barcode-scanner';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    SaleProductPickerPageRoutingModule,
    StylistPickerModule,
    ProductListComponentModule,
    SalonMonsterTapRetryModule,
    SalonMonsterLoadMaskModule,
  ],
  declarations: [SaleProductPickerPage],
  providers: [
   // BarcodeScanner
  ]
})
export class SaleProductPickerPageModule {}
